import gql from 'graphql-tag';

export const GET_WIZARDS_BY_DESTINATION = gql`
  query GetWizardsByDestination($filter: WizardFilterInput) {
    wizards(filter: $filter) {
      id
      type
      userId
      deletedAt
      completedAt
      title
      description
      successMessage
      startedAt
      currentStepId
      totalStepCount
      createdAt
      companyId
      steps {
        id
        title
        order
      }
    }
  }
`;
